import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationsComponent } from './notifications.component';
import {MatButtonModule, MatIconModule, MatTooltipModule} from '@angular/material';
import { NotificationComponent } from './notification/notification.component';
import {CallBarModule} from '../@theme/components/header/call-bar/call-bar.module';
import {CounterDirectiveModule} from '../@theme/directives/counter.directive.module';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  declarations: [
    NotificationsComponent,
    NotificationComponent
  ],
  exports: [
    NotificationsComponent
  ],
  imports: [
    CommonModule,
    MatTooltipModule,
    MatIconModule,
    MatButtonModule,
    CounterDirectiveModule,
    TranslateModule
  ],
})
export class NotificationsModule { }
